import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const standalone = () => window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
export default function DownloadPage() {
  const navigate = useNavigate();
  const [installed, setInstalled] = useState(() => standalone() || !!window.ghHomeInstall?.installed);
  const [busy, setBusy] = useState(false);
  const [guide, setGuide] = useState(false);
  const [message, setMessage] = useState('');
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const embedded = /MicroMessenger|FBAN|FBAV|Instagram|Line\//i.test(navigator.userAgent);
  const android = /Android/i.test(navigator.userAgent);
  useEffect(() => {
    const display = window.matchMedia('(display-mode: standalone)');
    const update = () => {
      const done = standalone() || !!window.ghHomeInstall?.installed;
      setInstalled(done);
      if (done) { setGuide(false); setMessage('已安装，可以从桌面打开 Global Heart。'); }
    };
    window.addEventListener('gh-install-change', update);
    display.addEventListener?.('change', update);
    return () => { window.removeEventListener('gh-install-change', update); display.removeEventListener?.('change', update); };
  }, []);
  async function install() {
    if (busy || installed) return;
    const event = window.ghHomeInstall?.prompt;
    setMessage('');
    if (!event) { setGuide(true); return; }
    window.ghHomeInstall.prompt = null;
    setBusy(true); setGuide(false);
    try {
      await event.prompt();
      const result = await event.userChoice;
      if (!window.ghHomeInstall?.installed) setMessage(result.outcome === 'accepted' ? '已确认安装，请等待系统完成后查看桌面图标。' : '已取消安装。你可以再次点击按钮查看手动添加方法。');
    } catch { setMessage('暂时无法弹出安装窗口，请按下面的方法添加。'); setGuide(true); }
    finally { setBusy(false); }
  }
  const steps = embedded
    ? ['点击当前浏览器右上角菜单，选择“在浏览器中打开”。', ios ? '使用 Safari 打开本站，点“分享” → “添加到主屏幕”。' : '使用 Chrome 打开本站，点菜单 → “添加到主屏幕”或“安装应用”。', '确认名称为 Global Heart，再点“添加”或“安装”。']
    : ios ? ['在 Safari 浏览器打开 globalheart.online/download。', '点“分享”（方框向上箭头；部分版本位于“更多”菜单），选择“添加到主屏幕”。', '如有“作为网页 App 打开”选项，请开启，再点“添加”。']
    : android ? ['在 Chrome 浏览器打开本站。', '点右上角 ⋮ 菜单，选择“添加到主屏幕”或“安装应用”。', '按系统提示确认，桌面就会出现 Global Heart 图标。']
    : ['要建立手机图标，请用手机浏览器打开 globalheart.online/download。', '安卓：Chrome 菜单 → 添加到主屏幕或安装应用。', 'iPhone：Safari 分享 → 添加到主屏幕 → 添加。'];
  return (
    <div className="page-content">
      <div className="discovery-header"><h2>📲 下载 Global Heart</h2><p className="subtitle">建立手机桌面图标，下次一点就能打开</p></div>
      <section aria-labelledby="home-icon-title" style={{ maxWidth: 640, margin: '20px auto', padding: 24, border: '1px solid #788bce', borderRadius: 20, background: 'rgba(79,124,255,.08)' }}>
        <img src="/icons/icon-192.png" alt="Global Heart" width="72" height="72" style={{ borderRadius: 18 }} />
        <h3 id="home-icon-title">把 Global Heart 放到手机桌面</h3>
        <p>无需应用商店，添加后可从桌面直接进入。使用时需要联网。</p>
        <button type="button" className="btn btn-primary btn-block" onClick={install} disabled={busy || installed}>{installed ? '已安装到桌面' : busy ? '请在系统窗口中确认…' : '一键建立手机图标'}</button>
        <p style={{ fontSize: 13, opacity: .8 }}>安卓支持时会弹出安装确认；iPhone 需通过分享菜单添加。</p>
        <div role="status" aria-live="polite">{message}</div>
        {!installed && <button type="button" className="btn btn-secondary" aria-expanded={guide} aria-controls="home-icon-guide" onClick={() => setGuide(!guide)}>{guide ? '收起添加说明' : '查看手动添加方法'}</button>}
        {guide && <div id="home-icon-guide" style={{ marginTop: 16 }}><h4>{embedded ? '请先在手机浏览器打开' : ios ? 'iPhone / iPad 添加方法' : android ? '安卓手机添加方法' : '在手机上建立图标'}</h4><ol style={{ paddingLeft: 22, lineHeight: 1.9 }}>{steps.map(step => <li key={step}>{step}</li>)}</ol><p>如果已经添加过，可直接回到桌面打开。</p></div>}
      </section>
      <div className="download-grid">
        <div className="download-card"><div className="download-icon">🤖</div><div className="download-name">Android APK</div><div className="download-desc">也可以下载安装安卓应用</div><p>下载 APK 后，按手机系统提示完成安装。</p><a className="btn btn-primary btn-block" href="/apk/GlobalHeart.apk">下载 APK</a></div>
        <div className="download-card coming-soon"><div className="download-icon">🍎</div><div className="download-name">iPhone / iPad</div><p>现在可通过上方按钮查看添加桌面图标的方法。</p><div className="download-badge">App Store 版本开发中</div></div>
        <div className="download-card coming-soon"><div className="download-icon">🔰</div><div className="download-name">鸿蒙 App</div><div className="download-badge">开发中</div></div>
      </div>
      <div className="download-footer"><button className="btn btn-primary" onClick={() => navigate('/')}>继续网页版</button></div>
    </div>
  );
}
